module.exports = __webpack_public_path__ + "img/dz.53b090e2.svg";